import { CustomerWidgetFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/customer-widget/catalog";
import { CustomerWidgetFlatTeamSettingGroups } from "../../flat-team-settings/customer-widget/groups";
import { ReturnsFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/returns/catalog";
import { ReturnsFlatTeamSettingGroups } from "../../flat-team-settings/returns/groups";
import { SupportFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/support/catalog";
import { SupportFlatTeamSettingGroups } from "../../flat-team-settings/support/groups";
import { defineSettingsProvider } from "../provider";
import type { SettingDefinition, SettingGroupDefinition } from "../types";

export const FlatTeamSettingsCatalogProvider = defineSettingsProvider({
  name: "flat team settings",
  groups: [
    ...CustomerWidgetFlatTeamSettingGroups,
    ...SupportFlatTeamSettingGroups,
    ...ReturnsFlatTeamSettingGroups,
  ],
  definitions: [
    ...CustomerWidgetFlatTeamSettingCatalogDefinitions,
    ...SupportFlatTeamSettingCatalogDefinitions,
    ...ReturnsFlatTeamSettingCatalogDefinitions,
  ],
});

export const FlatTeamSettingsCatalogGroups =
  FlatTeamSettingsCatalogProvider.groups satisfies readonly SettingGroupDefinition[];

export const FlatTeamSettingsCatalogDefinitions =
  FlatTeamSettingsCatalogProvider.definitions satisfies readonly SettingDefinition[];
